const divFileList = {
  text: 'Excluir',
  retry: 'Reenviar',
};

export default divFileList;
